/**
 * Internal shared helpers for the userContent service modules.
 *
 * Not part of the public surface — consumers should import from
 * `@shared/services/userContentService` (the facade), which re-exports the
 * domain modules (focus, videos, exercises, wellness, sequence).
 */
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { UserProfileEntry } from '../../types';

export const USER_CONTENT_COLLECTION = 'userContent';
export const DAILY_WELLNESS_SUBCOLLECTION = 'dailyWellness';
export const MOOD_HISTORY_SUBCOLLECTION = 'moodHistory';
export const FOCUS_SUBCOLLECTION = 'focus';
export const FOCUS_RESPONSES_SUBCOLLECTION = 'responses';
export const VIDEOS_SUBCOLLECTION = 'videos';
export const EXERCISES_SUBCOLLECTION = 'exercises';
export const EXERCISE_RESPONSES_SUBCOLLECTION = 'responses';
export const USER_PROFILE_SUBCOLLECTION = 'userProfile';

export const writeUserProfileEntries = async (
    uid: string,
    entries: Omit<UserProfileEntry, 'id' | 'createdAt'>[]
): Promise<void> => {
    const profileRef = collection(db, USER_CONTENT_COLLECTION, uid, USER_PROFILE_SUBCOLLECTION);
    for (const entry of entries) {
        await addDoc(profileRef, { ...entry, createdAt: serverTimestamp() });
    }
};

export const toIsoString = (value: any): string | undefined => {
    if (!value) return undefined;
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return new Date(value).toISOString();
    if (typeof value?.toDate === 'function') return value.toDate().toISOString();
    if (typeof value?.seconds === 'number') return new Date(value.seconds * 1000).toISOString();
    return undefined;
};
